'use client'

import React from 'react'
import {useTranslations} from 'next-intl'

import encodeBase64 from './encodeBase64'
import EncoderLayout from '../EncoderLayout'
import Checkbox from '../../../../components/elements/Checkbox'


export default function Base64Encoder() {
  const t = useTranslations()

  const [urlSafeMode, setUrlSafeMode] = React.useState(false)
  const onUrlSafeModeChange = (urlSafeMode) => {
    setUrlSafeMode(urlSafeMode)
  }

  return (
    <EncoderLayout
      encode={encodeBase64}
      options={{urlSafeMode}}
      optionControl={
        <Checkbox
          checked={urlSafeMode}
          onChange={onUrlSafeModeChange}
          label={t('base64-encoder.url-safe-option')}
        />
      }
    />
  )
}
